
//Style Imports
import styled from "styled-components";

type Props = {
  title: string;
  subText: string;
  icon: string;
} 

const AutomationItemCard = (props: Props) =>  {
  const { title, subText, icon} = props;
  return (
      <Wrapper className="d-flex justify-content-start" >
        <div className="icon-wrapper">
          <img src={icon} alt="icon" />
        </div>
        <div className="text-wrapper">
          <h4>{title}</h4>
          <span>{subText}</span>
        </div>
      </Wrapper>
  );
};

export default AutomationItemCard;


const Wrapper = styled.div`
    background-color:#FFFFFF;
    border-radius:8px;
    /* box-shadow:0px 0px 17px -2px rgba(0, 0, 0, 0.08); */
    padding:48px 32px 48px 32px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      padding:32px 28px 32px 28px;
      border-radius:6px;
    }
    .text-wrapper{
      margin-left:14px;
      h4{
        color:#001823;
        font-weight:500;
        font-family: "Roboto Slab", serif;
        font-size:24px;
        letter-spacing:-0.6px;
        margin:0 0 8px 0;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          font-size:20px;
        }
      }
      span{
        color:#001823;
        font-weight:400;
        font-size:16px;
        font-family: "Roboto", sans-serif;
        letter-spacing:-0.4px;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          font-size:14px;
        }
      }
    }
`;
